import {
  IHrStaffFilter,
  IAdvanceRequestFilter,
  IUpdateAdvancePayload,
  IUpdateBonusPayload,
  IUpdateRatingPayload,
  IUpdateSalaryPayload,
  INewOffPayload,
} from "@/features/management/management.types";
import { AxiosResponse } from "axios";
import { http } from "@/utils/http";
import { IWorkType } from "@/features/work-types/work-type.types";
import { cleanParams } from "@/utils/cleanParams";

export const managementService = {
  getList(filter?: IHrStaffFilter): Promise<AxiosResponse> {
    return http.get<IWorkType[]>("/hr/staff", {
      params: cleanParams(filter),
    });
  },

  advanceRequest(filter?: IAdvanceRequestFilter): Promise<AxiosResponse> {
    return http.get<IWorkType[]>("/hr/advance-requests", {
      params: cleanParams(filter),
    });
  },

  approveAdvance(user_id: string, advance_id: string): Promise<AxiosResponse> {
    return http.post(`/hr/users/${user_id}/advances/${advance_id}/approve`, {
      admin_comment: "",
    });
  },

  rejectAdvance(user_id: string, advance_id: string): Promise<AxiosResponse> {
    return http.post(`/hr/users/${user_id}/advances/${advance_id}/reject`, {
      admin_comment: "",
    });
  },

  getUserDetail(user_id: string, filter?: any): Promise<AxiosResponse> {
    return http.get(`/hr/users/${user_id}`, {
      params: cleanParams(filter),
    });
  },

  updateSalary(
    id: string,
    payload: IUpdateSalaryPayload
  ): Promise<AxiosResponse> {
    return http.patch(`/hr/users/${id}/salary`, payload);
  },

  updateAdvance(
    id: string,
    payload: IUpdateAdvancePayload
  ): Promise<AxiosResponse> {
    return http.post(`/hr/users/${id}/advances`, payload);
  },

  updateBonus(
    id: string,
    payload: IUpdateBonusPayload
  ): Promise<AxiosResponse> {
    return http.post(`/hr/users/${id}/recurring-bonuses`, payload);
  },

  updateRating(
    id: string,
    payload: IUpdateRatingPayload
  ): Promise<AxiosResponse> {
    return http.post(`/hr/users/${id}/ratings`, payload);
  },

  createOff(id: string, payload: INewOffPayload): Promise<AxiosResponse> {
    return http.post(`/hr/users/${id}/extra-offs`, payload);
  },

  updateOff(
    user_id: string,
    off_id: string,
    payload: INewOffPayload
  ): Promise<AxiosResponse> {
    return http.patch(`/hr/users/${user_id}/extra-offs/${off_id}`, payload);
  },

  deleteOff(user_id: string, off_id: string): Promise<AxiosResponse> {
    return http.delete(`/hr/users/${user_id}/extra-offs/${off_id}`);
  },
};
